(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StringReplaceEnhanced", [], factory);
	else if(typeof exports === 'object')
		exports["StringReplaceEnhanced"] = factory();
	else
		root["StringReplaceEnhanced"] = factory();
})(window, function() {
return 